import { useLanguage } from '../contexts/LanguageContext';

// Flag SVGs as components
const SpainFlag = () => (
  <svg viewBox="0 0 32 24" className="w-7 h-5 rounded shadow-sm">
    <rect width="32" height="24" fill="#c60b1e"/>
    <rect y="6" width="32" height="12" fill="#ffc400"/>
  </svg>
);

const USAFlag = () => (
  <svg viewBox="0 0 32 24" className="w-7 h-5 rounded shadow-sm">
    <rect width="32" height="24" fill="#fff"/>
    <g fill="#b22234">
      {[0,2,4,6,8,10,12].map(i => (
        <rect key={i} y={i * 1.846} width="32" height="1.846"/>
      ))}
    </g>
    <rect width="12.8" height="12.923" fill="#3c3b6e"/>
    <g fill="#fff">
      {/* Stars simplified */}
      <circle cx="1.6" cy="1.3" r="0.6"/>
      <circle cx="4.8" cy="1.3" r="0.6"/>
      <circle cx="8" cy="1.3" r="0.6"/>
      <circle cx="11.2" cy="1.3" r="0.6"/>
      <circle cx="3.2" cy="2.6" r="0.6"/>
      <circle cx="6.4" cy="2.6" r="0.6"/>
      <circle cx="9.6" cy="2.6" r="0.6"/>
      <circle cx="1.6" cy="3.9" r="0.6"/>
      <circle cx="4.8" cy="3.9" r="0.6"/>
      <circle cx="8" cy="3.9" r="0.6"/>
      <circle cx="11.2" cy="3.9" r="0.6"/>
      <circle cx="3.2" cy="5.2" r="0.6"/>
      <circle cx="6.4" cy="5.2" r="0.6"/>
      <circle cx="9.6" cy="5.2" r="0.6"/>
      <circle cx="1.6" cy="6.5" r="0.6"/>
      <circle cx="4.8" cy="6.5" r="0.6"/>
      <circle cx="8" cy="6.5" r="0.6"/>
      <circle cx="11.2" cy="6.5" r="0.6"/>
      <circle cx="3.2" cy="7.8" r="0.6"/>
      <circle cx="6.4" cy="7.8" r="0.6"/>
      <circle cx="9.6" cy="7.8" r="0.6"/>
      <circle cx="1.6" cy="9.1" r="0.6"/>
      <circle cx="4.8" cy="9.1" r="0.6"/>
      <circle cx="8" cy="9.1" r="0.6"/>
      <circle cx="11.2" cy="9.1" r="0.6"/>
      <circle cx="3.2" cy="10.4" r="0.6"/>
      <circle cx="6.4" cy="10.4" r="0.6"/>
      <circle cx="9.6" cy="10.4" r="0.6"/>
      <circle cx="1.6" cy="11.7" r="0.6"/>
      <circle cx="4.8" cy="11.7" r="0.6"/>
      <circle cx="8" cy="11.7" r="0.6"/>
      <circle cx="11.2" cy="11.7" r="0.6"/>
    </g>
  </svg>
);

export const LanguageSelector = ({ className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`flex items-center gap-1 bg-white/80 backdrop-blur-sm rounded-full p-1 shadow-sm border border-stone-200 ${className}`} data-testid="language-selector">
      <button
        onClick={() => setLanguage('es')}
        className={`p-1.5 rounded-full transition-all ${
          language === 'es' 
            ? 'bg-primary/20 ring-2 ring-primary shadow-sm scale-110' 
            : 'hover:bg-stone-100 opacity-70 hover:opacity-100'
        }`}
        title="Español"
        aria-label="Cambiar a Español"
      >
        <SpainFlag />
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`p-1.5 rounded-full transition-all ${
          language === 'en' 
            ? 'bg-primary/20 ring-2 ring-primary shadow-sm scale-110' 
            : 'hover:bg-stone-100 opacity-70 hover:opacity-100'
        }`}
        title="English"
        aria-label="Switch to English"
      >
        <USAFlag />
      </button>
    </div>
  );
};

export default LanguageSelector;
